import { useState, useMemo } from 'react';
import { useDebounce } from './useDebounce';

type UseListSearchOptions<T> = {
  source: T[] | null | undefined;
  searchBy: (item: T) => string | null | undefined; // 用哪個欄位來搜尋
  debounceMs?: number;
  initialKeyword?: string;
};

export function useListSearch<T>({
  source,
  searchBy,
  debounceMs = 220,
  initialKeyword = '',
}: UseListSearchOptions<T>) {
  const [keyword, setKeyword] = useState(initialKeyword);
  const debouncedKeyword = useDebounce(keyword, debounceMs);

  const filtered = useMemo(() => {
    if (!source) return null;

    const kw = debouncedKeyword.trim().toLowerCase();
    if (!kw) return source;

    return source.filter((item) => {
      const field = searchBy(item);
      if (field == null) return false;
      return String(field).toLowerCase().includes(kw);
    });
  }, [source, debouncedKeyword, searchBy]);

  const isSearching = debouncedKeyword.trim() !== '';

  const reset = () => setKeyword('');

  return {
    keyword,
    setKeyword,
    filtered,
    isSearching,
    reset,
  };
}
